export enum BatchIndicator {
  HatchedPercentage = 'hatchedPercentage',
  AirTemperature = 'airTemperature',
  AverageOvoscanAirTemperature = 'averageOvoscanAirTemperature',
  CO2 = 'co2',
  AverageEggTemperature = 'averageEggTemperature',
  Humidity = 'humidity',
}
